import ONVOCADO from './onvocado';
import BLACK_FRIDAY from './blackFriday';
import GRAY from './gray';
import MONOCHROME from './monochrome';
import BLACK_YELLOW from './blackYellow';

export default {
  ONVOCADO,
  BLACK_FRIDAY,
  GRAY,
  MONOCHROME,
  BLACK_YELLOW,
};